import {
    useCallback,
} from 'react'

import useSaveAttachments from '@src/api/hooks/useSaveAttachments'
import {
    PhotoType,
} from '@src/context/PhotosContext/PhotosContext'
import usePhotoContext from '@src/context/PhotosContext/usePhotoContext'
import useFlowRouter from '@src/shared-components/FlowRouter/useFlowRouter'

const useSaveAttachmentsFromContext = (onSuccess:()=> void) => {
    const {
        state,
    } = useFlowRouter()
    const {
        savePhotoIds,
        photos: contextPhotos,
    } = usePhotoContext()
    const afterSaveAttachment = useCallback((results: PhotoType[]) => {
        savePhotoIds(results)
        onSuccess()
    }, [
        savePhotoIds,
        onSuccess,
    ])

    const {
        mutate: saveAttachements,
        error,
        isPending: isLoading,
        reset: resetErrors,
    } = useSaveAttachments(`${state.gatewayMac}`, `${state.email}`, afterSaveAttachment)

    const save = useCallback(() => {
        const notSavedPhotos = contextPhotos.filter((photo) => {
            return photo.filePath === undefined
        })

        return saveAttachements(notSavedPhotos)
    }, [
        saveAttachements,
        contextPhotos,
    ])

    return {
        error,
        isLoading,
        save,
        resetErrors,
    }
}

export default useSaveAttachmentsFromContext
